import React, { useState } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';

import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useMutation } from '@apollo/client';
import { ADD_COMMENT, UPDATE_COMMENT } from './comment.graphql';
import { Modal } from '../dialogs/useModal';

export interface CategoryCommentDialogInput {
  categoryId: string;
  commentId?: string;
  comment?: string | null;
}

export function CategoryCommentDialog({ modal }: { modal: Modal<CategoryCommentDialogInput, boolean> }) {
  const { categoryId, commentId, comment } = modal.data;
  const [workingComment, setWorkingComment] = useState(comment);
  const [updateComment, { loading: updating }] = useMutation(UPDATE_COMMENT, {
    variables: { input: { commentId, text: workingComment } },
  });
  const [addComment, { loading: adding }] = useMutation(ADD_COMMENT, { variables: { input: { categoryId, text: workingComment } } });

  const handleClose = () => {
    modal.close(false);
  };

  const handleOk = async () => {
    if (commentId) {
      await updateComment();
    } else {
      await addComment();
    }

    modal.close(true);
  };

  const heading = commentId ? 'Endre kommentar' : 'Ny kommentar';
  const saving = updating || adding;
  return (
    <div>
      <Dialog open={true} onClose={handleClose} aria-labelledby="form-dialog-title" fullWidth>
        <DialogTitle id="form-dialog-title">{heading}</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            name="comment"
            type="text"
            multiline
            onChange={(event) => setWorkingComment(event.target.value)}
            value={workingComment}
            minRows={4}
            fullWidth
            autoFocus
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Avbryt</Button>
          <Button disabled={saving || !workingComment?.trim()} onClick={handleOk} variant="contained" color="primary">
            {saving ? 'Lagrer...' : commentId ? 'Endre' : 'Legg til'}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
